/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { liveImagePathNew as BASE_IMAGE_PATH } from '../configs/const';

class UnderMaintenance extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <>
                <div className='alllbl-maintenance'>
                    <div className='maintenance-box'>
                        <div className='maintenance-images'><img src={BASE_IMAGE_PATH + "/casino/banner/images/under-maintenance-all-lbl.jpg"} alt=''></img></div>
                        <div className='maintenance-title'>{this.props.inMaitanenceMessage.message}</div>
                        <div className='maintenance-p'>From {moment(this.props.inMaitanenceMessage.from + '+00:00').format('DD MMM YYYY HH:mm')} To {moment(this.props.inMaitanenceMessage.to + '+00:00').format('DD MMM YYYY HH:mm')}.</div>
                        <div className='maintenance-p'>SORRY FOR THE INCONVENIENCE!</div>
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(UnderMaintenance);